import { KeenSliderInstance, KeenSliderOptions } from "keen-slider";
import { ref } from "vue";

export const useKeenSliderConfig = () => {
    const areButtonsVisible = ref(false);
    const isButtonLeftDisabled = ref(true);
    const isButtonRightDisabled = ref(false);
    const current = ref(0);
    const slideCount = ref(3);

    const handleSlideChanged = (s: KeenSliderInstance) => {
        if (!s.track?.details) {
            return;
        }

        areButtonsVisible.value = s.track.details?.minIdx !== s.track.details?.maxIdx;

        const slidePos = s.track.details.rel;

        isButtonLeftDisabled.value = slidePos === 0;

        isButtonRightDisabled.value = slidePos === s.track.details.maxIdx;

        current.value = slidePos;
        slideCount.value = s.track.details.maxIdx + 1;
    };

    const config: KeenSliderOptions = {
        slides: {
            spacing: 12,
            perView: "auto",
            origin: "auto",
        },
        slideChanged: handleSlideChanged,
        updated: handleSlideChanged,
        created: handleSlideChanged,
    };

    return {
        config,
        areButtonsVisible,
        isButtonLeftDisabled,
        isButtonRightDisabled,
        handleSlideChanged,
        current,
        slideCount,
    };
};

export type SliderConfig = ReturnType<typeof useKeenSliderConfig>;
